import { Check } from 'lucide-react'
import { useState } from 'react'
import {
	Command,
	CommandEmpty,
	CommandGroup,
	CommandInput,
	CommandItem,
	CommandList,
} from '@/components/ui/command'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog'
import { cn } from '@/lib/utils'

export interface SearchableSelectItem {
	id: string
	name: string
	code?: string
}

interface SearchableSelectDialogProps {
	open: boolean
	onOpenChange: (open: boolean) => void
	title: string
	description?: string
	items: SearchableSelectItem[]
	selectedId: string
	onSelect: (id: string) => void
}

export function SearchableSelectDialog({
	open,
	onOpenChange,
	title,
	description,
	items,
	selectedId,
	onSelect,
}: SearchableSelectDialogProps) {
	const [search, setSearch] = useState('')

	return (
		<Dialog
			open={open}
			onOpenChange={(open) => {
				if (!open) setSearch('')
				onOpenChange(open)
			}}
		>
			<DialogContent className="max-w-md p-0 gap-0 overflow-hidden">
				<DialogHeader className="px-4 pt-4 pb-2">
					<DialogTitle>{title}</DialogTitle>
					{description && <DialogDescription>{description}</DialogDescription>}
				</DialogHeader>
				<Command shouldFilter={true}>
					<CommandInput
						placeholder="Buscar..."
						value={search}
						onValueChange={setSearch}
					/>
					<CommandList className="max-h-[300px]">
						<CommandEmpty>No se encontraron resultados</CommandEmpty>
						<CommandGroup>
							{items.map((item) => (
								<CommandItem
									key={item.id}
									value={`${item.name} ${item.code || ''}`}
									onSelect={() => {
										onSelect(item.id)
										setSearch('')
										onOpenChange(false)
									}}
									className="cursor-pointer"
								>
									<Check
										className={cn(
											'h-4 w-4 mr-2 shrink-0',
											selectedId === item.id ? 'opacity-100' : 'opacity-0'
										)}
									/>
									<div className="flex flex-col min-w-0">
										<span className="truncate">{item.name}</span>
										{item.code && (
											<span className="text-xs text-muted-foreground truncate">{item.code}</span>
										)}
									</div>
								</CommandItem>
							))}
						</CommandGroup>
					</CommandList>
				</Command>
			</DialogContent>
		</Dialog>
	)
}
